import { actionTypes } from '../../../controller';
import jwt from '../../../../lib/jwt';

const { SET_JWT, SAVE_JWT_TO_LOCAL_STORAGE, CLEAR_JWT } = actionTypes;

export function jwtMiddleware() {
	return next => action => {
		const { type, jwt: token } = action;

		if (type === SET_JWT) {
			jwt.current = token;
		} else if (type === SAVE_JWT_TO_LOCAL_STORAGE) {
			jwt.saveToLocal();
		} else if (type === CLEAR_JWT) {
			jwt.removeCurrent();
		}

		next(action);
	};
}
